import { style } from 'glamor';
import React from 'react';
import Link from 'gatsby-link';
import _ from 'lodash';

const styles = {
  title: style({
    fontSize: '32px',
    marginBottom: '2px',
    // '@media(max-width: 460px)': {
    //   maxWidth: '100%',
    // },
  }),
  date: style({
    fontSize: '14px'
  }),
  characterLink:style({
    fontSize:'12px'
  }),
  img: style({
    // maxWidth:'600px'
  })
}

export default ({node:{title, date, image, characters}}) =>
  <fragment>
    <h2 className={styles.title}>{title}</h2>
        <div className={styles.date}>{new Date(date).toLocaleDateString()}</div>
        <img className={styles.img} src={_.get(image,'file.url')}/>
        <div>
        {characters && <span className={styles.characterLink}>Characters: </span>}
        {characters && characters.map(({title, contentful_id}) => {
          const link=`/character/${contentful_id}`;

          return (<Link key={contentful_id} to={link} className={styles.characterLink}>[{title}]</Link>)
        })}
        </div>
    </fragment>



// WEBPACK FOOTER //
// ./src/components/Cartoon.js